import { ICellData } from "Interfaces/ICellData";
import { IParser } from "Interfaces/IParser";
import Student from "Models/Student";
import StudentMap from "Models/StudentMap";
import moment from "moment";
const dateNowObj = moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD");

type IType = "TA" | "GA" | "FRR" | "JFD" | "Banner" | "";
export default abstract class ScheduleEntry implements IParser<ScheduleEntry> {
	start: moment.Moment = null;
	duration: number = 0; // in days
	end: moment.Moment = null;
	season: number = 0;
	name: string = "";
	type: string = "";
	group: string = "";
	offset: number = 0; // in days
	student: Student = null;
	img: string = "";
	abstract parse(row: ICellData[]): ScheduleEntry;
}
const map = new StudentMap();
type IColor = "Red" | "Blue" | "Yellow" | "Purple" | "";

export class TicketScheduleEntry extends ScheduleEntry {
	group = "Tickets";
	type = "Ticket";
	reference: any;

	parse(row: ICellData[]): TicketScheduleEntry {
		return new TicketScheduleEntry();
	}

	static fromGA(raid: RaidScheduleEntry): TicketScheduleEntry {
		const tse = new TicketScheduleEntry();
		tse.name = "GA"+raid.season;
		tse.start = raid.end.clone().add(1, "days");
		tse.end = tse.start.clone().add(2, "months").startOf("month");
		tse.duration = tse.end.diff(tse.start, "days");
		tse.reference = raid;
		tse.season = raid.season;
		tse.group = "Tickets"+((raid.season%3)+1);
		return tse;
	}
}

export class RaidScheduleEntry extends ScheduleEntry {
	terrain: string = "";
	atk: IColor = "";
	def: IColor = "";
	def2: IColor = "";
	def3: IColor = "";
	parse(row: ICellData[]): RaidScheduleEntry {
		const se = new RaidScheduleEntry();
		let i=0;
		se.start = moment(row[i++]?.f ?? '', "YYYY-MMM-DD");
		se.duration = parseInt(row[i++]?.v ?? '0');
		i++;
		se.end = se.start.clone().add(se.duration, "days");
		se.season = parseInt(row[i++]?.v ?? '0');
		se.name = row[i++]?.v?.trim() ?? '';
		se.terrain = row[i++]?.v?.trim() ?? '';
		se.type = (row[i++]?.v?.trim() ?? '') as IType;
		se.atk = (row[i++]?.v?.trim() ?? '') as IColor;
		se.def = (row[i++]?.v?.trim() ?? '') as IColor;
		se.def2 = (row[i++]?.v?.trim() ?? '') as IColor;
		se.def3 = (row[i++]?.v?.trim() ?? '') as IColor;
		const student = row[i++]?.v?.trim() ?? '';
		if (student) {
			se.student = Student.fromId(map.getIdFromUnknown(student));
		}
		se.img = row[i++]?.v ?? '';
		return se;
	}
}

export class BannerScheduleEntry extends ScheduleEntry {
	students: string[] = [];
	eta: number = 0; // in days
	parse(row: ICellData[]): BannerScheduleEntry {
		const se = new BannerScheduleEntry();
		if (!!!row[0]?.v) return null;
		se.type = "Banner";
		se.group = "Banners";
		let i=0;
		se.students = [];
		se.name = row[i++]?.v ?? '';
		se.start = moment(row[i++]?.f ?? '', "YYYY-MMM-DD");
		se.eta = this.parseEta(row);
		se.duration = parseInt(row[i++]?.v ?? '0');
		se.end = se.start.clone().add(se.duration, "days");
		return se;
	}
	
	parseEta(data:ICellData[]): number {
		const i = 1
		const eta = moment(data[i]?.f ?? '', "YYYY-MMM-DD").diff(dateNowObj, "days");
		if (Number.isNaN(eta))
			return moment(data[i]?.f ?? '', "YYYY-MM-DD").diff(dateNowObj, "days")
		return eta
	}
	static merge(entries: BannerScheduleEntry[]): BannerScheduleEntry[] {
		const data: {[eta: number]: BannerScheduleEntry} = {};
		for (const match of entries) {
			if (!!!match) continue;
			if (!data[match.eta]) data[match.eta] = match;
			data[match.eta].students.push(match.name);
		}
		
		return Object.values(data).sort((a, b) => a.start.valueOf() - b.start.valueOf());
	}
}
